<template>
    <div class="container mt-2">
        <div class="card">
            <div class="card-body">
                <button @click="makePointConfirm" class="btn btn-success btn-block btn-lg" type="button">ポイント発行</button>
            </div>
        </div>

        <make-point-confirm ref="confirm" :msg="msg" :lev="2" @ok="confirmOK"></make-point-confirm>

    </div>
</template>

<script>
    import MakePointConfirm from 'pages/commons/modal/infoMsg/InfoMsg'

    export default {
        data () {
            return {
                msg: ""
            }
        },
        components: {
            MakePointConfirm
        },
        methods: {
            confirmOK () {
                let time = this.$moment(new Date).format('YYYYMM')
                this.makePoint(time)
            },
            makePoint (pay_num) {
                this.$store.dispatch('makePoint',{
                    pay_num: pay_num
                })
            },
            makePointConfirm () {
                let time = this.$moment(new Date).format('YYYY-MM')
                this.msg = "【" + time + "】" + "のポイントを発行しますか？"

                this.$refs.confirm.openThis()
            }
        }
    }
</script>

<style>

</style>
